const reducer = (state:any = [], action:any) =>{

    if(action.type === 'CREATE_DAYS_STATE'){
        state = [...action.payload];
        return state;
    }

    else if(action.type === 'CHANGE_DAY_STATE'){
        let filteredState = state.filter((x:any)=> (x.day.date.isSame(action.payload.day.date))==false);
        state = [...filteredState, action.payload];
        return state;
    } 

    else if(action.type === 'CHANGE_ALL_DAY_STATE'){
        let tempState = [...state];
        tempState.forEach(element => {
            if(element.day.isVisible)
                element.day.isChecked = action.payload
        });

        state = [...tempState];
        return state;
    } 
    
    else if (action.type === 'CLEAN_DAYS_STATE'){
        state = [];
        return state;
    } 
    else{
        return state
    }
}

export default reducer;